import { persistentReducedStream, reducer } from '@ardoq/rxbeach';
import {
  activeSlideIsOutdated,
  loadVisualizationSlideSuccess,
} from './actions';

const startLoading = (): boolean => true;
const finishLoading = (): boolean => false;

export const slideIsLoading$ = persistentReducedStream<boolean>(
  'slideIsLoading$',
  false,
  [
    reducer(activeSlideIsOutdated, startLoading),
    reducer(loadVisualizationSlideSuccess, finishLoading),
  ]
);
